import variables from 'themes/variables'

const { sizes } = variables.breakpoints

export const BELOW_DESKTOP_MEDIA_QUERY = `(max-width: ${sizes.medium})`

export const isDesktopViewport = () =>
  typeof window === 'undefined' ||
  !window.matchMedia ||
  !window.matchMedia(BELOW_DESKTOP_MEDIA_QUERY).matches

let panelIdCounter = 0

export const createPanelId = () => {
  panelIdCounter += 1
  return `program-nav-dropdown-${panelIdCounter}`
}

let activeDropdown = null

// Only one program nav menu is open at a time: opening one closes the last.
export const claimActiveDropdown = ({ close, isPointerHeadingInside }) => {
  if (activeDropdown && activeDropdown.close !== close) {
    activeDropdown.close()
  }
  activeDropdown = { close, isPointerHeadingInside }
}

export const releaseActiveDropdown = close => {
  if (activeDropdown?.close === close) {
    activeDropdown = null
  }
}

export const isAnotherDropdownOpen = close =>
  !!activeDropdown && activeDropdown.close !== close

export const isPointerHeadingIntoAnotherDropdown = close =>
  isAnotherDropdownOpen(close) && activeDropdown.isPointerHeadingInside()

export const isPointInRect = ({ point, rect, padding = 0 }) =>
  !!rect &&
  point.x >= rect.left - padding &&
  point.x <= rect.right + padding &&
  point.y >= rect.top - padding &&
  point.y <= rect.bottom + padding

const crossProduct = (point, start, end) =>
  (point.x - end.x) * (start.y - end.y) - (start.x - end.x) * (point.y - end.y)

export const isPointInTriangle = ({ point, corners: [a, b, c] }) => {
  const sides = [
    crossProduct(point, a, b),
    crossProduct(point, b, c),
    crossProduct(point, c, a),
  ]
  const hasNegative = sides.some(side => side < 0)
  const hasPositive = sides.some(side => side > 0)
  return !(hasNegative && hasPositive)
}

/**
 * True when the pointer, moving from `from` to `to` above the panel, is inside
 * the triangle between `from` and the panel's top edge, i.e. aiming at it.
 */
export const isHeadingIntoRect = ({ from, to, rect, padding = 0 }) => {
  if (!from || !to || !rect || to.y >= rect.top) return false
  if (from.x === to.x && from.y === to.y) return false

  return isPointInTriangle({
    point: to,
    corners: [
      from,
      { x: rect.left - padding, y: rect.top },
      { x: rect.right + padding, y: rect.top },
    ],
  })
}

export const isModifiedClick = event =>
  event.button !== 0 ||
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey
